import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BaseComponent} from "common-shared";
import {ActivatedRoute} from "@angular/router";
import {debounceTime, distinctUntilChanged, Subject} from "rxjs";
import {switchMap, takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-page-search',
  templateUrl: './page-search.component.html',
  styles: [],
  host: {
    class: 'd-flex'
  }
})
export class PageSearchComponent extends BaseComponent implements OnInit {
  public searchOptions: { enabled?: boolean, advanced?: boolean, initialStateOfAdvanced?: boolean } = {};

  @Input() searchString: string;
  @Output() searchStringChange = new EventEmitter<string>();

  @Input() showFilters = false;
  @Output() showFiltersChange = new EventEmitter<boolean>();
  @Input() debounceTime: number = 200;
  protected searchText$ = new Subject<string>();

  constructor(private activatedRoute: ActivatedRoute) {
    super();
  }

  toggleAdvanced(): void {
    this.showFilters = !this.showFilters;
    this.showFiltersChange.emit(this.showFilters);
  }

  ngOnInit() {
    if (this.activatedRoute.routeConfig && this.activatedRoute.routeConfig.data) {
      this.searchOptions = this.activatedRoute.routeConfig.data['search'] || {
        advanced: false,
        enabled: false,
        initialStateOfAdvanced: null
      };

      if (this.searchOptions.initialStateOfAdvanced != null) {
        this.showFilters = this.searchOptions.initialStateOfAdvanced;
        setTimeout(() => {
          this.showFiltersChange.emit(this.showFilters);
        }, 100);
      }
    }

    this.searchText$.pipe(
      debounceTime(this.debounceTime),
      distinctUntilChanged(),
      takeUntil(this.componentDestroyed))
      .subscribe(value => {
        this.searchStringChange.emit(value);
      })
    ;
  }

  onPaste(event: ClipboardEvent) {
    let pastedText = event.clipboardData.getData('text');
    pastedText = pastedText.trim();
    const inputElement = document.activeElement as HTMLInputElement;
    const finalCursorPosition = inputElement.selectionStart + pastedText.length;
    inputElement.setRangeText(pastedText);
    inputElement.setSelectionRange(finalCursorPosition, finalCursorPosition);
    this.searchString = inputElement.value;
    this.searchStringChange.emit(this.searchString);
    event.preventDefault();
  }
}
